var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNounReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.698,
    height: 24.455,
    viewBox: "0 0 18.698 24.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6a709f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.119,5.687h3.668L32.1,1V4.668A1.022,1.022,0,0,0,33.119,5.687Z",
    transform: "translate(-18.65 -0.491)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.169,6.216a2.044,2.044,0,0,1-2.038-2.038V0H7.228A1.5,1.5,0,0,0,5.7,1.528v21.4a1.533,1.533,0,0,0,1.528,1.528H22.869A1.533,1.533,0,0,0,24.4,22.926V6.216Zm-9.731,6.267a1.507,1.507,0,0,1,.509.1L12.527,10.9a1.027,1.027,0,0,1-.153-.56,1.172,1.172,0,1,1,2.344,0,.459.459,0,0,1-.051.255l1.172.815a1.037,1.037,0,0,1,.764-.306.889.889,0,0,1,.611.2L18.59,9.731a1.086,1.086,0,0,1-.153-.611,1.172,1.172,0,1,1,1.172,1.172,1.81,1.81,0,0,1-.509-.1l-1.427,1.63a1.488,1.488,0,0,1,.1.459,1.172,1.172,0,1,1-2.344,0,.382.382,0,0,1,.051-.255l-1.172-.815a1.157,1.157,0,0,1-.815.306.861.861,0,0,1-.509-.153l-1.579,1.681a1.086,1.086,0,0,1,.153.611,1.172,1.172,0,1,1-2.344,0A1.268,1.268,0,0,1,10.438,12.482Zm6.776,9.833H7.789V21.3h9.425Zm5.095-2.242H7.789V19.054h14.52Zm0-2.293H7.789V16.762h14.52Z",
    transform: "translate(-5.7)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounReport);
export default __webpack_public_path__ + "static/media/noun_report.4f3747e60bc63dedc1184e37dfa1ce72.svg";
export { ForwardRef as ReactComponent };